
const ExpertiseSection = () => {
  const expertiseAreas = [
    {
      icon: 'ri-oil-line',
      title: 'Upstream Solutions',
      description: 'Specialized chemical systems for acid stimulation, matrix treatments, scale inhibition, and enhanced oil recovery applications.',
      features: [
        'Acid stimulation and matrix treatments',
        'Scale inhibition and water shut-off systems',
        'Formation damage removal',
        'Enhanced oil recovery (EOR) applications',
        'Coiled tubing and well intervention support'
      ],
      image: 'https://public.readdy.ai/ai/img_res/f4ba39ffd4857897acabe895b35574b1.jpg'
    },
    {
      icon: 'ri-shield-line',
      title: 'Corrosion Mitigation',
      description: 'Customized inhibitors, passivation systems, and cleaning agents for midstream and downstream operations.',
      features: [
        'Pipeline and process system protection',
        'Storage facility treatments',
        'Refining operation chemicals',
        'Transport unit maintenance',
        'Long-term integrity solutions'
      ],
      image: 'https://readdy.ai/api/search-image?query=Industrial%20pipeline%20system%20with%20corrosion%20protection%20coating%2C%20midstream%20oil%20and%20gas%20infrastructure%20with%20advanced%20anti-corrosion%20treatments%2C%20steel%20pipes%20with%20protective%20chemical%20applications%20in%20industrial%20facility&width=600&height=400&seq=corrosion&orientation=landscape'
    },
    {
      icon: 'ri-flask-line',
      title: 'Custom Formulations',
      description: 'Tailor-made chemical solutions for diverse industries including food-grade, cosmetics, and water treatment applications.',
      features: [
        'Food-grade and technical applications',
        'Cosmetics and personal care chemicals',
        'Water treatment solutions',
        'Industrial process optimization',
        'Regulatory compliance assurance'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20chemical%20laboratory%20with%20scientists%20developing%20custom%20formulations%2C%20advanced%20testing%20equipment%20and%20chemical%20synthesis%20apparatus%2C%20clean%20professional%20lab%20environment%20with%20beakers%20and%20analytical%20instruments&width=600&height=400&seq=custom&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ⚙️ Our Core Expertise
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            With over 20 expert engineers, we deliver cutting-edge chemical solutions 
            that address the toughest operational challenges in the energy sector.
          </p>
        </div>

        <div className="space-y-20">
          {expertiseAreas.map((area, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mr-4">
                    <i className={`${area.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">{area.title}</h3>
                </div>
                <p className="text-lg text-gray-600 mb-6">{area.description}</p>
                <ul className="space-y-3">
                  {area.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <i className="ri-check-line text-teal-600 text-xl mr-3 mt-0.5"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1">
                <img 
                  src={area.image}
                  alt={area.title}
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
